import { animationsForProvider } from 'Pods/ThreeDStudio/Shared/Utils/animationsForProvider'

import { ACTION, DEFAULT_ANIMATE_SETTINGS } from '../constants'
import { threeDStudioStore } from '../index'

const setAnimateState = (patch) => {
  threeDStudioStore.setState((state) => ({
    animateSettings: { ...state.animateSettings, ...patch },
  }))
}

/**
 * Resets all animate settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    animateSettings: { ...DEFAULT_ANIMATE_SETTINGS },
  })
}

/**
 * Sets the animation picked from the library
 * @param {string|null} animationId - Library animation id, or null to clear the selection
 */
export const setAnimationId = (animationId) => {
  setAnimateState({ animationId })
}

/**
 * Clears the picked animation when the engine about to become active cannot run
 * it, so the generate button drops back to disabled instead of submitting a clip
 * the provider has no counterpart for. Mirrors resetSettingsUnsupportedByProvider
 * on the generation flow; a no-op outside the animate flow and for a selection
 * the provider supports.
 *
 * @param {string} provider - Provider id about to become the active engine
 */
export const resetAnimationUnsupportedByProvider = (provider) => {
  const { schema, animateSettings } = threeDStudioStore.getState()
  const { animationId } = animateSettings
  if (schema.enhancedAction !== ACTION.ANIMATION || animationId == null) {
    return
  }

  if (animationsForProvider(provider).some(({ id }) => id === animationId)) {
    return
  }

  setAnimateState({ animationId: null })
}
